import React, { useContext } from "react"; //
import {
  //
  bearlog,
  BearDiv,
  BearFloat,
  BearSelect,
  BearBalance,
} from "@sillyscribe95/bear-ui-web";
import { MainContext } from "../context/MainContext";
import { AiOutlineArrowRight, AiOutlineArrowLeft } from "react-icons/ai";
import { chordKeyDict } from "../consts/chordConst";

export function KeyArrows() {
  const { overKeye, setoverKeye, currChord, pitchPlus, picho, shiftpic } =
    useContext(MainContext);

  function acasd(nmmo, children) {
    function onClick() {
      shiftpic(nmmo);
    }

    return BearDiv({
      className: "expandHover pointer",
      children,
      onClick,
    });
  }

  const arrelef = AiOutlineArrowLeft();
  const arrright = AiOutlineArrowRight();

  const left = acasd(-1, arrelef);
  const right = acasd(1, arrright);

  const optionsArray = ["Major", "Minor", "Diminished"];

  bearlog.log(`___ overKeye ___`, overKeye);

  // overKeye, setoverKeye
  const onasBASE = BearSelect({
    optionsArray,
    initialValue: overKeye,
    // value: overKeye,
    notClearable: true,
    onChangeValue: setoverKeye,
    width: "30vw",
  });

  const center =
    //
    // pitchPlus;
    BearBalance(currChord, onasBASE);
  // chordKeyDict[pitchPlus];

  bearlog.lug(`___ chordKeyDict ___`, { pitchPlus, picho, chordKeyDict });

  const jasdfewr = BearFloat({
    fontSize: "24px",
    left,
    center,
    right,
  });

  return jasdfewr;
}
